var applyFade = function (target) {
    var _a, _b, _c, _d, _e, _f, _g;
    var maxScrollLeft = target.scrollWidth - target.clientWidth;
    var targetAbsoluteScroll = Math.abs(target.scrollLeft);
    if (targetAbsoluteScroll >= maxScrollLeft - 10) {
        // @ts-ignore
        (_a = target.classList).add.apply(_a, ['unfade-end']);
        (_b = target.classList).remove.apply(_b, ['fade-end']);
    }
    else {
        (_c = target.classList).add.apply(_c, ['fade-end']);
        (_d = target.classList).remove.apply(_d, ['unfade-end']);
    }
    if (targetAbsoluteScroll <= 10) {
        (_e = target.classList).remove.apply(_e, ['fade-start']);
        (_f = target.classList).remove.apply(_f, ['fade-end']);
    }
    else {
        (_g = target.classList).add.apply(_g, ['fade-start']);
    }
};

export { applyFade };
